import { getCurrentLanguage } from "./index";

export function formatDate(dateString: string): string {
  const lang = getCurrentLanguage();
  return new Date(dateString).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateLong(dateString: string): string {
  const lang = getCurrentLanguage();
  return new Date(dateString).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateShort(dateString: string): string {
  const lang = getCurrentLanguage();
  return new Date(dateString).toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", {
    day: "numeric",
    month: "short",
  });
}

export function formatTime(dateString: string): string {
  const lang = getCurrentLanguage();
  return new Date(dateString).toLocaleTimeString(lang === "en" ? "en-GB" : "fr-FR");
}

export function formatDateTime(dateString: string): string {
  const lang = getCurrentLanguage();
  return new Date(dateString).toLocaleString(lang === "en" ? "en-GB" : "fr-FR");
}
